import React from "react";
import { BrowserRouter } from "react-router-dom";

import Router from "./router/Router";

const Auth = () => {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
};

export default Auth;
